import { Typography, Box } from "@mui/material";
import { FormQuestion } from "./FormQuestion";
import { questionType } from "../types";
import { shouldQuestionRender } from "../libs/questionLib";

type Props = {
	section: string;
	questions: questionType[];
	fields: {
		[key: string]: string;
	};
	handleOnChange: any;
	errorFields: string[];
};

export const SectionQuestions = (props: Props) => {
	const { section, questions, fields, handleOnChange, errorFields } = props;
	return (
		<Box>
			<Typography
				sx={{ flex: "0 0 100%", textTransform: "capitalize" }}
				variant="h6"
			>
				{section}
			</Typography>
			{questions.map((questionData) => {
				if (!shouldQuestionRender(questionData, fields)) return;
				const { name, question, allowedValues, type, required, helperText } = questionData;
				return (
					<FormQuestion
						key={name}
						value={fields[name]}
						name={name}
						question={question}
						allowedValues={allowedValues}
						handleOnChange={handleOnChange}
						type={type}
						error={!!errorFields.find((field) => field === name)}
						required={required}
						helperText={helperText}
					/>
				);
			})}
		</Box>
	);
};
